import './MainView.css';
import { Card, Col, Row, Typography } from 'antd';
import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  ExperimentOutlined,
  MessageOutlined,
  RobotOutlined,
  SettingOutlined
} from '@ant-design/icons';
import AgentDefinitions from './AgentDefinitions';
import AgentInteraction from './AgentInteraction';
import AgentInteractionV2 from './AgentInteractionV2';
import ErrorBanner from './components/ErrorBanner';
import {
  PlaygroundContext,
  PlaygroundProvider
} from './context/PlaygroundContext';
import DirectModelInteraction from './DirectModelInteraction';
import { BASE_PATH } from './routes';

const { Title, Paragraph } = Typography;

const MainContent: React.FC = () => {
  const { currentView, setCurrentView } = useContext(PlaygroundContext);
  const history = useHistory();
  const location = useLocation();

  if (location.pathname === `${BASE_PATH}/main/agent-runner`) {
    return <AgentInteractionV2 />;
  }

  if (currentView === 'direct') {
    return <DirectModelInteraction />;
  }

  if (currentView === 'agent') {
    return <AgentInteraction />;
  }

  if (currentView === 'definitions') {
    return <AgentDefinitions />;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f5f5f5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
    >
      <div style={{ width: '100%', maxWidth: 1000 }}>
        <div
          style={{
            textAlign: 'center',
            marginBottom: 48
          }}
        >
          <ExperimentOutlined
            style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }}
          />
          <Title level={2} style={{ margin: 0, marginBottom: 8 }}>
            LLM Playground
          </Title>
          <Paragraph type="secondary" style={{ fontSize: 16, margin: 0 }}>
            Test and experiment with our LLM infrastructure
          </Paragraph>
        </div>

        <Row gutter={[24, 24]} justify="center">
          <Col xs={24} sm={24} md={8}>
            <Card
              hoverable
              style={{
                height: '100%',
                borderRadius: 8,
                border: '1px solid #f0f0f0',
                cursor: 'pointer',
                textAlign: 'center',
                minHeight: 200
              }}
              className="feature-card"
              onClick={() => setCurrentView('direct')}
            >
              <MessageOutlined
                style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }}
              />
              <Title level={4} style={{ marginBottom: 8 }}>
                Direct Model Interaction
              </Title>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                Chat directly with an LLM model of your choice
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Card
              hoverable
              style={{
                height: '100%',
                borderRadius: 8,
                border: '1px solid #f0f0f0',
                cursor: 'pointer',
                textAlign: 'center',
                minHeight: 200
              }}
              className="feature-card"
              onClick={() => setCurrentView('agent')}
            >
              <RobotOutlined
                style={{ fontSize: 48, color: '#52c41a', marginBottom: 16 }}
              />
              <Title level={4} style={{ marginBottom: 8 }}>
                AI Agent Interaction
              </Title>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                Interact with an existing Melio AI agent
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Card
              hoverable
              style={{
                height: '100%',
                borderRadius: 8,
                border: '1px solid #f0f0f0',
                cursor: 'pointer',
                textAlign: 'center',
                minHeight: 200
              }}
              className="feature-card"
              onClick={() => setCurrentView('definitions')}
            >
              <SettingOutlined
                style={{ fontSize: 48, color: '#722ed1', marginBottom: 16 }}
              />
              <Title level={4} style={{ marginBottom: 8 }}>
                Agent Definitions
              </Title>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                View configuration details of available agents
              </Paragraph>
            </Card>
          </Col>

          <Col xs={24} sm={24} md={8}>
            <Card
              hoverable
              style={{
                height: '100%',
                borderRadius: 8,
                border: '1px solid #f0f0f0',
                cursor: 'pointer',
                textAlign: 'center',
                minHeight: 200
              }}
              className="feature-card"
              onClick={() => history.push(`${BASE_PATH}/main/agent-runner`)}
            >
              <RobotOutlined
                style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }}
              />
              <Title level={4} style={{ marginBottom: 8 }}>
                Agent Runner
              </Title>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                Quick agent execution with results
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const MainView: React.FC = () => {
  return (
    <PlaygroundProvider>
      <ErrorBanner />
      <MainContent />
    </PlaygroundProvider>
  );
};

export default MainView;
